// TODO(reseller) obtain the lists from window.labelBundle.cqts here
// "locally" is the shared reseller that local, dev and QA hostnames resolve to
// (db.themes), which is what makes both CQTs testable outside a production tenant.
const RESELLERS_WITH_CUSTOM_QUESTIONS = {
    'cambridgeup': ["ipa", "syntaxtree"],
    'locally': ["ipa", "syntaxtree"],
};

async function _merge_type_data(base) {
    if (!base) return {};
    const data = await (await fetch(`${base}type.json`)).json();
    data.js.question = `${base}question.js`;
    data.js.scorer = `${base}scorer.js`;
    data.editor_layout = `${base}authoring_custom_layout.html`;
    return data;
}

async function _merge_template_data(base) {
    if (!base) return [];
    const data = await (await fetch(`${base}template.json`)).json();
    data[0].defaults.js.question = `${base}question.js`;
    data[0].defaults.js.scorer = `${base}scorer.js`;
    return data;
}

//IPA
export function getIpaCqtBaseUrl(): string {
    if (!hasCustomQuestions("ipa")) return "";
    const base = (window as Window).edrnaConfig?.cqt_base_url ?? "";
    return base ? base.replace(/\/?$/, `/${window.labelBundle.reseller}/`) + "ipa/" : "";
}

async function getIpaTemplate() {
    return await _merge_template_data(getIpaCqtBaseUrl());
}

async function getIpaCqt() {
    return await _merge_type_data(getIpaCqtBaseUrl());
}

//Syntax Tree
export function getSyntaxTreeCqtBaseUrl(): string {
    if (!hasCustomQuestions("syntaxtree")) return "";

    const base = (window as Window).edrnaConfig?.cqt_base_url ?? "";
    return base ? base.replace(/\/?$/, `/${window.labelBundle.reseller}/`) + "syntaxtree/" : "";
}

async function getSyntaxTreeTemplate() {
    return await _merge_template_data(getSyntaxTreeCqtBaseUrl());
}

async function getSyntaxTreeCqt() {
    return await _merge_type_data(getSyntaxTreeCqtBaseUrl());
}

export function customQuestions() {
    const ipa = getIpaCqtBaseUrl();
    const st = getSyntaxTreeCqtBaseUrl();
    if (!ipa && !st) return [];
    return [
        ...(ipa
            ? [
                  {
                      type: "junction_ipa_transcription",
                      js: { question: ipa + "question.js", scorer: ipa + "scorer.js" },
                  },
              ]
            : []),
        ...(st
            ? [
                {
                    type: "junction_syntax_tree",
                    js: { question: st + "question.js", scorer: st + "scorer.js" },
                }
              ]
            : []),
    ];
}

export async function questionTypeTemplates() {
    const ipa = await getIpaTemplate();
    const st = await getSyntaxTreeTemplate();
    return {
        ...(ipa.length ? { junction_ipa_transcription: ipa } : {}),
        ...(st.length ? { junction_syntax_tree: st } : {}),
    };
}

export function questionTypeGroups() {
  const base = getIpaCqtBaseUrl();
  if (!base) return [];

  return [
    {
      "name": "Custom Question Types",
      "reference": "ipa_questions"
    }]
}

export async function customQuestionTypes() {
    return [await getIpaCqt(), await getSyntaxTreeCqt()].filter((cqt) => Object.keys(cqt).length > 0);
}

export function hasCustomQuestions(question_type) {
    if (question_type) {
        return RESELLERS_WITH_CUSTOM_QUESTIONS[window.labelBundle.reseller]?.includes(question_type)
    }
    return RESELLERS_WITH_CUSTOM_QUESTIONS[window.labelBundle.reseller] || []
}

export function getIPACustomQuestions() {
    const IPA_BASE = getIpaCqtBaseUrl();
    if (!IPA_BASE) return [];

    const IPA_CUSTOM_QUESTIONS = [{
      "custom_type": "junction_ipa_transcription",
      "name": "IPA Transcription",
      "description": "Students compose IPA phonetic transcriptions using a symbol keyboard",
      "js": {
        "question": IPA_BASE + "question.js",
        "scorer":   IPA_BASE + "scorer.js"
      },
      "editor": {
        "js": IPA_BASE + "editor.js"
      },
      "version": "v1.0.0"
    }];

    return IPA_CUSTOM_QUESTIONS;
}

export function getSyntaxTreeCustomQuestions() {
  const SYNTAX_TREE_BASE = getSyntaxTreeCqtBaseUrl();
  if (!SYNTAX_TREE_BASE) return [];

  const SYNTAX_TREE_CUSTOM_QUESTIONS = [{
      "custom_type": "junction_syntax_tree",
      "name": "Syntax Tree",
      "description": "Students draw and label phrase-structure trees for linguistic syntax.",
      "js": {
        "question": SYNTAX_TREE_BASE + "question.js",
        "scorer":   SYNTAX_TREE_BASE + "scorer.js"
      },
      // NO "editor" key here: this is the PLAYER registration. editor.js is an
      // anonymous AMD define(); a second one (alongside IPA's) collides and hangs
      // the Learnosity init on every assessment save. Authoring uses its own path.
      "version": "v1.5.0"
    }];

    return SYNTAX_TREE_CUSTOM_QUESTIONS;
}

export const CustomAssessmentTypes = {
  junction_ipa_transcription: 'IPA Transcription',
}
